import { ReactNode, useEffect, useState } from 'react'
import { removeAxeptioCookies } from 'lib/utils/cookies'

type ClientPageProps = {
  children: ReactNode
}

export function ClientPage({ children }: ClientPageProps) {
  const [isClientSide, setIsClientSide] = useState(false)

  useEffect(() => {
    setIsClientSide(true)
  }, [isClientSide])

  useEffect(() => {
    removeAxeptioCookies()
  }, [])

  return isClientSide ? <>{children}</> : null
}
